<template>
  <PageTemplate>
    <v-sheet class="item" color="transparent" width="100%">
      <v-container class="pt-10 pb-12">
        <Title class="text-center">Política de Privacidade</Title>

        <v-row justify="center" class="mt-6 mt-sm-8">
          <v-col cols="12">
            <Template class="font--secondary" />
          </v-col>
        </v-row>
      </v-container>
    </v-sheet>
  </PageTemplate>
</template>

<script>
import PageTemplate from "../templates/Page.vue";
import Title from "../widgets/Title.vue";
import Template from "../templates/PolicyPrivacy.vue";

export default {
  components: {
    PageTemplate,
    Title,
    Template,
  },
};
</script>
